import React from 'react';
import { Layout } from 'antd';
import ServiceableUrls from '../serviceableUrls/ServiceableUrls';
import useUrlState from '../../hooks/useUrlState';
import DomainSetupCheck from '../websiteIndexEntry/DomainSetupCheck';
import WebsiteIndexEntryTabs from '../websiteIndexEntry/WebsiteIndexEntryTabs';


const { Content } = Layout;

export default function MonitoredUrlsPage() {
    const [urlState] = useUrlState();
    const { w_guid: websiteGuid } = urlState;

    return (
        <Content className="general-layout-content">
            <WebsiteIndexEntryTabs>
                <DomainSetupCheck
                    key={websiteGuid}
                    websiteGuid={websiteGuid}
                >
                    <ServiceableUrls websiteGuid={websiteGuid!} />
                </DomainSetupCheck>
            </WebsiteIndexEntryTabs>
        </Content>
    );
}
